import sendAjax from '@/api/http'

export default {
  // 登录
  postLogin: params => {
    return sendAjax('post', 'login', params)
  },
  // 修改密码发送验证码
  sendSmsCode: params => {
    return sendAjax('post', 'register/sendSmsCode4ResetPW', params)
  },
  // 修改密码
  changePassword: params => {
    return sendAjax('post', 'register/resetPW', params)
  },
  // 创建运营者
  createOperator: params => {
    return sendAjax('post', 'account/createOperator', params)
  },
  // 运营者列表
  findOperator: () => {
    return sendAjax('get', 'account/findOperator')
  },
  // 删除运营者
  deleteOperator: params => {
    return sendAjax('post', 'account/delete', params)
  },
  // 启用运营者
  enableOperator: params => {
    return sendAjax('post', 'account/enable', params)
  },
  // 停用运营者
  deactivateOperator: params => {
    return sendAjax('post', 'account/ban', params)
  },
}


